/*
 * healthmart
 * version 2.2
 * http://www.healthmart.com
 *
 * Copyright (c) 2019 healthmart ltd
 * Author healthmart ltd <support@healthmart.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input, Output, forwardRef, ElementRef, EventEmitter, ViewChild, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusinessProfileService } from 'src/app/pages/business-profile/services/business-profile.service';
declare var $: any;

@Component({
    selector: 'app-select-control',
    templateUrl: './select-control.component.html',
    styleUrls: ['./select-control.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectControlComponent),
            multi: true
        }],
    standalone: false
})

export class SelectControlComponent implements OnInit, ControlValueAccessor, OnDestroy {
    @ViewChild('searchInput') searchInput!: ElementRef;
    @Input() inputType: any;
    @Input() notFromEQuoteCountry: boolean=true;
    @Input() currentValue: any;
    @Input() inputPlaceHolder: string;
    @Input() inputId: string;
    @Input() inputName: string;
    @Input() inputWrapperClass: string;
    @Input() labelText: string;
    @Input() lableClass: string = 'label fs-5 text-1 fw-500';
    @Input() inputClass: string = 'form-control fs-6 my-3 ms-3 p-3 border-0 bg-7 br-05';
    @Input() icon: string;
    @Input() iconClass: string;
    @Input() iconWrapperClass: string = 'input-group-text border-0 bg-7 br-05 my-t-b-3';
    @Input() error: any;
    @Input() errorMessage: any;
    @Input() errorMessage_required: any;
    @Input() errorMessage_pattern: any;
    @Input() checked: boolean;
    @Input() additionInputClass: string;
    @Input() fcontrol: any;
    @Input() itemList: any;
    @Input() selectedId: any;
    @Input() index: any;
    @Input() type: any;
    @Input() moduleName:any;
    businessDataArr:any
    private _unsubscribeAll: Subject<any> = new Subject();


    listfordisplay: any;
    searchValue: any;

    dateName: any;
    @ViewChild('input') inputRef: ElementRef;

    @Output() emptyDecorator: EventEmitter<any> = new EventEmitter();
    @Output() TextChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() keyup: EventEmitter<any> = new EventEmitter<any>();
    @Output() changeValue: EventEmitter<any> = new EventEmitter<any>();

    touched = false;       

    constructor(private translateService: TranslateService,    private businessProfileService: BusinessProfileService,private cdr: ChangeDetectorRef,
        ) { }

    ngOnInit(): void {
        if(this.notFromEQuoteCountry){
            let merchant_id = localStorage.getItem('merchant_id');
            console.log('selected id 1', this.selectedId) 
            const getBusinessProfileSubs = this.businessProfileService.getBusinessProfile('', merchant_id).pipe(takeUntil(this._unsubscribeAll)).subscribe((val: any) => {
                if (val && val.data) {
                    this.businessDataArr = val.data;
                    if (this.businessDataArr.merchant_contact_numbers && this.businessDataArr.merchant_contact_numbers.length > 0) {
                        // this.selectedId = this.businessDataArr.merchant_contact_numbers[0].countryId ? this.businessDataArr.merchant_contact_numbers[0].countryId : this.selectedId;
                        // console.log(this.selectedId,"<<<<this.selectedIdthis.selectedId")
                        // const country = this.listfordisplay.find(y => y.id === this.selectedId);
                        // if (country) {
                        //     // If found, do something with the country object
                        //     console.log(country,'ddddddddddddddd');
                        // }
                    }
                }
            });
            
            this.listfordisplay = this.itemList;
            this.dateName = this.inputName;        
            this.inputClass = this.inputClass + ' ' + this.additionInputClass;   
        }else{
            this.cdr.detectChanges()
            this.reloadList()

        }
                  
    }

    onTouched: any = () => { };
    ngOnChanges() { }

    //The internal data model for form control value access
    private innerValue: any = '';

    // event fired when input value is changed . later propagated up to the form control using the custom value accessor interface
    onChange(e: Event, value: any) {
        this.touched = true;
        //set changed value
        this.innerValue = value;
        // propagate value into form control using control value accessor interface
        this.propagateChange(this.innerValue);
        this.keyup.emit(true);
    }

    onSearchList(event) {
        this.listfordisplay = this.search(event.target.value);
    }

    search(value: string) {
        const filter = value?.toLowerCase()?.trim();
        const type = this.type;
      
        if (!Array.isArray(this.itemList) || this.itemList.length === 0) {
          return [];
        }
      
        if (filter) {
          return this.itemList.filter((options) => {
            let optionName = '';
            let phoneCode = '';
      
            if (type === 'contacts') {
              const customerRelation = options.merchant_customers_relations?.[0];
              const customerNumber = customerRelation?.customerNumber || '';
              const firstName = options.firstname?.toLowerCase() || '';
              const lastName = options.lastname?.toLowerCase() || '';
              phoneCode = options.phone_code?.toString() || '';
      
              optionName = `${customerNumber} ${firstName} ${lastName}`;
            } else {
              optionName = options.name?.toLowerCase() || '';
              phoneCode = options.phone_code?.toString() || '';
            }
      
            return (
              optionName.includes(filter) ||
              phoneCode.includes(filter)
            );
          });
        }
      
        return this.itemList;
      }
      

   
    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
        }
    }

    //propagate changes into the custom form control
    propagateChange = (_: any) => { }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (this.innerValue !== undefined) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }

    reloadList() {        
        this.listfordisplay = this.itemList;
    }

    async searchOptions(event: any, type, ix) {
        this.touched = true;        
    }

    async selectChange(event: any) {          
        $('.select-input-value').val('');        
        if(this.index >= 0) {
            this.changeValue.emit({'index': this.index, "type": this.type, "value": event.value});
        } else {
            this.changeValue.emit(event);
        }
    }

    onDropdownOpen(opened: boolean) {
        if (opened) {
          setTimeout(() => {
            this.searchInput?.nativeElement?.focus();
          }, 0); // Delay to allow DOM to update
        }
      }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(undefined);
        this._unsubscribeAll.complete();
    }
}